import axios from 'axios'
import urls from './urls'
import querystring from 'querystring'

const verifyEmail = async function ({ email }) {
  try {
    let data = {
      email
    }
    let parameterizedUrl = urls.emailVerification + '?' + querystring.stringify(data)
    const res = await axios.get(parameterizedUrl)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

const activateAccount = async function ({ email, username, password }) {
  try {
    let data = {
      email,
      username,
      password,
      'fcm': null
    }
    const res = await axios.post(urls.accountActivation, data)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

const editAccount = async function ({ username, imageUrl, phone }, idUser) {
  try {
    let data = {
      phone,
      imageUrl,
      username
    }
    console.log('data', data)
    const res = await axios.put(urls.editAccount + idUser, data)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

const changePassword = async function ({ oldPassword, newPassword }) {
  try {
    let data = {
      oldPassword: oldPassword,
      newPassword: newPassword,
    }
    const res = await axios.post(urls.changePassword, data)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

export {
  verifyEmail,
  activateAccount,
  editAccount,
  changePassword,
}
